import React, { useCallback, useEffect, useState } from 'react';
import { addOptionsWatchlist, getOptionsGrid, getOptionsWatchlist, refreshOptionsGrid, removeOptionsWatchlist } from '../api/options';
import ProfessionalOptionsGrid from '../components/ProfessionalOptionsGrid';

export default function OptionsGridPage({ ticker }) {
  const [data, setData] = useState(null);
  const [state, setState] = useState({ loading: true, error: null });
  const [watchlist, setWatchlist] = useState([]);
  const params = new URLSearchParams(window.location.search);
  const [query, setQuery] = useState({ expiration: params.get('expiration') || '', strikes: params.get('strikes') || '8' });
  const initialStrategy = params.get('strategy') || '';
  const load = useCallback((override = {}) => {
    const next = { ...query, ...override };
    setQuery(next); setState({ loading: true, error: null });
    getOptionsGrid(ticker, next).then(result => { setData(result); setState({ loading: false, error: null }); }).catch(error => setState({ loading: false, error }));
  }, [ticker, query]);
  useEffect(() => {
    load();
    getOptionsWatchlist().then(setWatchlist).catch(() => setWatchlist([]));
  }, [ticker]);
  const toggleWatch = async symbol => {
    if (watchlist.some(item => item.option_symbol === symbol)) await removeOptionsWatchlist(symbol);
    else await addOptionsWatchlist(symbol);
    setWatchlist(await getOptionsWatchlist());
  };
  const refreshSource = async () => {
    setState({ loading: true, error: null });
    try {
      await refreshOptionsGrid(ticker);
      load();
    } catch (error) {
      setState({ loading: false, error });
    }
  };
  return <main className="og-page"><ProfessionalOptionsGrid data={data} ticker={ticker} loading={state.loading} error={state.error} onRefresh={load} onRefreshSource={refreshSource} initialStrategy={initialStrategy} watchlist={watchlist} onToggleWatch={toggleWatch}/></main>;
}